import { compact, noop } from 'underscore';
import { dateFilterPlugin } from '@bingads-webui-campaign/projection-grid-date-filter';
import { hotelCenterOverviewBulkEdit } from './overview-bulk-edit';

export const extendPlugins = ({
  serverContext,
  toolbarPlugin,
  crossPageSelectPlugin,
  appConfig,
  i18n,
  hotelCenterI18n,
  filterService,
  BulkEditBidPanel,
  BulkEditBidMultiPanel,
  BulkIncreaseDecreaseBidPanel,
  gridName,
  appState,
  p$daterange,
}) => () => compact([
  toolbarPlugin,
  (gridName === 'HotelIdGrid' || gridName === 'HotelGroupGrid') && crossPageSelectPlugin,
  {
    plugin: dateFilterPlugin,
    config: {
      state: appState,
      isOdataActionSource: false,
      addDateChangeListener: noop,
      p$daterange,
    },
  },
  {
    plugin: definePlugin => definePlugin('filterState', [], noop),
  },
  {
    plugin: definePlugin => definePlugin('filter', [], noop),
  },
  {
    plugin: definePlugin => definePlugin('quickFilter', [], noop),
  },
  (gridName === 'HotelIdGrid' || gridName === 'HotelGroupGrid') && {
    plugin: hotelCenterOverviewBulkEdit({
      serverContext,
      config: appConfig,
      filterService,
      i18n,
      gridName,
      hotelCenterI18n,
      BulkEditBidPanel,
      BulkEditBidMultiPanel,
      BulkIncreaseDecreaseBidPanel,
    }),
  },
]);
